import { EEmitentZadaOpridISIN } from 'enums/isin/emitentZadaOpridISIN';

const emitentZadaOpridISINselect = [
    {
        value: EEmitentZadaOpridISIN.LISTINNY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_ISIN_LIST'
    },
    {
        value: EEmitentZadaOpridISIN.ZAKNIHOVANY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_ISIN_ZAKN'
    },
    {
        value: EEmitentZadaOpridISIN.IMOBILIZOVANY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_ISIN_IMOB'
    },
    {
        value: EEmitentZadaOpridISIN.LISTSBER,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_ISIN_SBER'
    }
];

export default emitentZadaOpridISINselect;
